<div class="main-page-content">
  <div class="main-page-content-block">



    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                  sortField="TimeElapsed" [sortOrder]="-1">

          <ng-template pTemplate="caption">
            <div class="d-flex justify-content-end ">

              <div class="p-2 flex-fill"><h1 class="content-heading-font">Web Site Executing Requests</h1></div>
              <div class="ml-auto">              
                <button class="btn btn-primary " (click)="loadTable(null)" title="Refresh">
                  <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>
                &nbsp;
                <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
                  <i class="pi pi-filter-slash"></i>
                </button>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="text-center d-none d-xxl-table-cell">
                GUID
                <p-sortIcon field="GUID"></p-sortIcon>
                <p-columnFilter type="text" field="GUID" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="SiteName" class="text-start ">
                Web Site
                <p-sortIcon field="SiteName"></p-sortIcon>
                <p-columnFilter type="text" field="SiteName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Date" class="text-center" style="width:130px;">
                Time<p-sortIcon field="Date"></p-sortIcon>
                <p-columnFilter type="date" field="Date" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="TimeElapsed" class="text-end">
                Time Elapsed (ms) <p-sortIcon field="TimeElapsed"></p-sortIcon>
                <p-columnFilter type="numeric" field="TimeElapsed" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="ClientIPAddress" class="text-center">
                IP Address
                <p-sortIcon field="ClientIPAddress"></p-sortIcon>
                <p-columnFilter type="text" field="ClientIPAddress" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="PipelineState" class="text-start">
                State
                <p-sortIcon field="PipelineState"></p-sortIcon>
                <p-columnFilter type="text" field="PipelineState" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="CurrentModule" class="text-start">
                Module
                <p-sortIcon field="CurrentModule"></p-sortIcon>
                <p-columnFilter type="text" field="CurrentModule" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Url" class="text-start">
                Url
                <p-sortIcon field="Url"></p-sortIcon>
                <p-columnFilter type="text" field="Url" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item >
            <tr>
              <th class="text-center d-none d-xxl-table-cell">
                {{ item.RequestGUID }}
              </th>
              <td class="text-start text-nowrap ">
                <a href="#" [routerLink]="['/developer/websites/'+  item.SiteId ]">
                  {{ item.SiteName || item.HostName  }}
                </a>  #{{ item.ProcessId }}
              </td>
              <td class="text-center text-nowrap ">
                <span title="{{ item.Date | date: 'short' }}"> {{ getTimeFromNow(item.Date) }}</span>
              </td>
              <td class="text-end  " [ngClass]="{'fw-bold text-danger bg-dark': item.TimeElapsed>5000}">
                {{ item.TimeElapsed /1000.0 | number: '1.2-2' }} s
              </td>
              <td class="text-center text-nowrap ">
                {{ item.ClientIPAddress }} #{{ item.ConnectionId }}
              </td>
              <td class="text-start text-nowrap ">
                {{ item.PipelineState }} ({{ item.TimeInState /1000.0 | number: '1.2-2' }} s)
              </td>
              <td class="text-start text-nowrap ">
                {{ item.CurrentModule }} ({{ item.TimeInModule /1000.0 | number: '1.2-2' }} s)
              </td>
              <td class=" text-break text-truncate " style="max-width: 10vw;">
                {{ item.Verb }} <a href="https://{{ item.HostName }}{{ item.Url }}" target="_blank"> {{ item.Url }} </a>
              </td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10">No items found.</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary " (click)="loadTable(null)" title="Refresh">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>
</div>



